import { render, staticRenderFns } from "./CloseButtonSetting.vue?vue&type=template&id=4207b724&scoped=true&"
import script from "./CloseButtonSetting.vue?vue&type=script&lang=ts&"
export * from "./CloseButtonSetting.vue?vue&type=script&lang=ts&"
import style0 from "./CloseButtonSetting.vue?vue&type=style&index=0&id=4207b724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4207b724",
  null
  
)

export default component.exports